import './index.less';

import React, { useState } from 'react';

import IconMarker from '../../images/map.png';
import { checkFlagLarge } from '../../utils/flag';

const FranchiseMap = () => {
  const [selectedLocation, setSelectedLocation] = useState('sg');

  const getFranchiseLocationDetail = () => {
    switch (selectedLocation) {
      case 'sg':
        return (
          <div className="map-title">
            <img src={checkFlagLarge(selectedLocation)} alt="singapore" />
            <h1>Singapore</h1>
          </div>
        );
      case 'us':
        return (
          <div className="map-title">
            <img src={checkFlagLarge(selectedLocation)} alt="los angeles" />
            <h1>Los Angeles</h1>
          </div>
        );
      case 'es':
        return (
          <div className="map-title">
            <img src={checkFlagLarge(selectedLocation)} alt="madrid" />
            <h1>Madrid</h1>
          </div>
        );
      case 'ch':
        return (
          <div className="map-title">
            <img src={checkFlagLarge(selectedLocation)} alt="Zürich" />
            <h1>Zürich</h1>
          </div>
        );
      case 'cn':
        return (
          <div className="map-title">
            <img src={checkFlagLarge(selectedLocation)} alt="shanghai" />
            <h1>Shanghai</h1>
          </div>
        );
      case 'br':
        return (
          <div className="map-title">
            <img src={checkFlagLarge(selectedLocation)} alt="sao-paulo" />
            <h1>São Paulo</h1>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className="franchise-map-wrapper">
        <img src={IconMarker} className="franchise-map-img" alt="map" />
        <div
          onClick={() => {
            setSelectedLocation('sg');
          }}
          className={`franchise-map-dot singapore ${selectedLocation === 'sg' && 'active'}`}
        />
        <div
          onClick={() => {
            setSelectedLocation('us');
          }}
          className={`franchise-map-dot la ${selectedLocation === 'us' && 'active'}`}
        />
        <div
          onClick={() => {
            setSelectedLocation('es');
          }}
          className={`franchise-map-dot madrid ${selectedLocation === 'es' && 'active'}`}
        />
        <div
          onClick={() => {
            setSelectedLocation('ch');
          }}
          className={`franchise-map-dot zurich ${selectedLocation === 'ch' && 'active'}`}
        />
        <div
          onClick={() => {
            setSelectedLocation('cn');
          }}
          className={`franchise-map-dot shanghai ${selectedLocation === 'cn' && 'active'}`}
        />
        <div
          onClick={() => {
            setSelectedLocation('br');
          }}
          className={`franchise-map-dot saopaulo ${selectedLocation === 'br' && 'active'}`}
        />
      </div>
      <div className={`franchise-map-detail map-${selectedLocation}`}>{getFranchiseLocationDetail()}</div>
    </div>
  );
};

export default FranchiseMap;
